import * as angular from "angular";
import {IController} from "angular";
import {AgreementDialogService} from "../../services/agreement-dialog-service.service";
import {AgreementService} from "../../services/agreement-service.service";

export class agreementsTableRowCtrl implements IController {
  agreement: any;

  constructor(private $log, private apiConfig, private $window,
              private agreementDialogService: AgreementDialogService, private agreementService: AgreementService) {
  }


  edit(event) {
    this.agreementDialogService.editAgreementVersion(event, this.agreement)
      .then((version) => {
        this._updateAgreementVersion(this.agreement.id, version);
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  private _updateAgreementVersion(agreementId, version) {
    this.agreementService.updateVersion(agreementId, version)
      .then((updatedVersion) => {
        this.agreement.latestVersion = updatedVersion;
      })
      .catch((error) => {
        if (error) {
          this.$log.error('Failed to edit agreement @agreementTableRow@edit', error);
        }
      })
  }

  clickLinkButton (event){
    const url = this.apiConfig.baseUrl + '/v1/policy/' + this.agreement.id;
    this.$window.open(url, '_blank');
  }


}

angular
  .module('bringoz.admin.agreements')
  .component('agreementsTableRow', {
    bindings: {
      agreement: '<'
    },
    template: require('./agreements-table-row.html').default,
    controller: agreementsTableRowCtrl
  });

